/* eslint-disable css-modules/no-unused-class */
import { useDispatch } from 'react-redux';

// Design System
import { PlusOutlined } from 'jl-design-system/components/icons/PlusOutlined';

// Types
import { AppDispatch } from 'types/RootState.types';
import { AddressBookModalPlaceholderProps } from './AddressBookModalPlaceholder.types';

// Config
import { navigateTo } from '@redux/actions/navigation/navigationActions';

// Styles
import styles from './address-book-modal.scss';

const AddressBookModalPlaceholder = ({
  disabled = false,
  id = '',
  onClick = () => {},
  path = '',
  text = '',
}: AddressBookModalPlaceholderProps) => {
  const dispatch: AppDispatch = useDispatch();

  const handleButtonClick = () => {
    dispatch(navigateTo(path));
    onClick();
  };

  return (
    <div>
      <button
        className={styles.placeholderContent}
        data-testid={id}
        disabled={disabled}
        onClick={handleButtonClick}
        type="button"
      >
        <PlusOutlined className={styles.placeholderIcon} size="large" />
        <span>{text}</span>
      </button>
    </div>
  );
};

export default AddressBookModalPlaceholder;
